import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m12 8.402 4.544-1.774-11.25-4.4-3.88 1.517a2.3 2.3 0 0 0-.545.305zM.053 5.312A2.2 2.2 0 0 0 0 5.786v11.212c0 .9.56 1.708 1.415 2.043l8.635 3.377q.587.228 1.2.313V9.69zm12.697 17.42a5.3 5.3 0 0 0 1.2-.313l8.636-3.377A2.2 2.2 0 0 0 24 16.998V5.786q0-.241-.052-.475L12.75 9.69zm10.381-18.68L18.562 5.84l-11.25-4.4L10.05.367a5.36 5.36 0 0 1 3.9 0l8.636 3.377q.294.116.546.305z"
    }, null, -1)
  ]))]))
}
export default { render: render }